import { Pipe, PipeTransform } from '@angular/core';
import { getStatusBadgeClass } from '../utils/status-class.util';

export type StatusBadgeClassMode = 'default' | 'enrolled';

@Pipe({
  name: 'statusBadgeClass',
  standalone: true,
})
export class StatusBadgeClassPipe implements PipeTransform {
  transform(status: string | null | undefined, mode: StatusBadgeClassMode = 'default'): string {
    if (mode === 'enrolled') {
      return getStatusBadgeClass(status, {
        exactMap: {
          Completed: 'status-enrolled',
          Enrolled: 'status-enrolled',
        },
        patterns: [[/enrolled|completed/, 'status-enrolled']],
      });
    }

    return getStatusBadgeClass(status);
  }
}
